// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 15 15", width: "15", height: "15" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", null,
                React.createElement("path", { d: "M1038,322.005798 C1038,320.345742 1039.34435,319 1040.99942,319 L1050.00058,319 C1051.65711,319 1053,320.348816 1053,322.005798 L1053,326.994202 C1053,328.654258 1051.66163,330 1050.00795,330 L1048.9126,330 L1049,334 L1044,330 L1041,330 C1039.34315,330 1038,328.651184 1038,326.994202 L1038,322.005798 Z", transform: "translate(-1038 -319)" })))));
};
Icon.displayName = 'CommentBubble15x15';
export default Icon;
//# sourceMappingURL=CommentBubble15x15.js.map